import { styled } from '@material-ui/core';
import { MediaType } from '../../../model/frontendmodel';

const MediaPreview = styled('div')(() => ({
  lineHeight: 0,
  height: 'inherit',
  '& img, & .thumbnail': {
    width: '100%',
    height: '100%',
    maxWidth: '800px',
    backgroundRepeat: 'no-repeat',
  },

  '& img': {
    maxWidth: '800px',
    objectFit: 'cover',
    maxHeight: '80vh',
    backgroundRepeat: 'no-repeat',
    imageRendering: 'crisp-edges',
    width: 'auto',
    height: 'auto',
  },

  '& .thumbnail': {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
  },

  '& video': {
    width: '100%',
    height: '100%',
    maxWidth: '800px',
    maxHeight: '800px',
    objectFit: 'cover',
  },
}));

interface MediaCaptionPreviewProps {
  src: string;
  alt?: string;
  type: MediaType.IMAGE | MediaType.VIDEO;
  thumbnail?: boolean;
}

const MediaCaptionPreview: React.FC<MediaCaptionPreviewProps> = ({
  src,
  type = MediaType.IMAGE,
  alt = '',
  thumbnail = false,
}) => (
  <MediaPreview>
    {type === MediaType.IMAGE && (
      <>
        {thumbnail && (
          <div
            className="thumbnail"
            style={{ backgroundImage: `url(${src})` }}
          />
        )}
        {!thumbnail && <img src={src} alt={alt} />}
      </>
    )}
    {type === MediaType.VIDEO && (
      // eslint-disable-next-line jsx-a11y/media-has-caption
      <video controls={!thumbnail} width="100%">
        <source src={src} />
      </video>
    )}
  </MediaPreview>
);
export default MediaCaptionPreview;
